import { Actions } from '@makemydeal/dr-sales-checkin-store';
import { initActionTypes } from '@makemydeal/dr-shared-store';

// Actions that (re)seed the buyer the title is built from.
const triggerActionTypes = new Set([
    initActionTypes.INIT_PENCIL_SUCCESS, // bootstrap resolved — deal seeded from the init payload
    Actions.UPDATE_DEAL_SUCCESS, // deal saved — the buyer may have changed
    Actions.FETCH_DEAL_SUCCESS, // deal refreshed (GTL / websocket-driven reload)
    Actions.UPDATE_PARTICIPANT_DETAILS // buyer edited in the customer card — updates checkedInCustomer only
]);

export const documentTitleMiddleware = (store: any) => (next: any) => (action: any) => {
    const result = next(action); // always propagate — reducers run here, seeding the buyer

    if (triggerActionTypes.has(action.type)) {
        store.dispatch({ type: initActionTypes.UPDATE_DOCUMENT_TITLE });
    }

    return result;
};
